<template>
    <v-container>
        <div class="headline">Nøkler</div>

        <v-btn color="success">
            <v-icon left>mdi-key</v-icon>
            Generer nøkkel
        </v-btn>

        <v-data-table :items="keys" :headers="headers" :mobile-breakpoint="0" disable-pagination hide-default-footer>
            <template v-slot:item.createdAt="{item}">
                {{moment.unix(item.createdAt).format("YYYY-MM-DD HH:mm")}}
            </template>
             <template v-slot:item.expire="{item}">
                {{moment.unix(item.createdAt).format("YYYY-MM-DD HH:mm")}}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import * as moment from "moment";
export default {
    data() {
        return {
            keys: [
                {
                    name: "Nilkeys",
                    token: "eyanadonsgd.adfnadfi132423mkrfw2f.23ron234onfowinf",
                    createdAt: 1590663545,
                    expire: 1590673545
                }
            ],
            headers: [
                { text: "Navn", value: "name"},
                { text: "Nøkkel", value: "token"},
                { text: "Opprettet på", value: "createdAt"},
                { text: "Utløper", value: "expire"},
            ],
            moment: moment,
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss">
</style>